<template>
  <div>
    <Topbar />
    <div id="content">
        <div class="container">
            <div class="login_wrapper col-12 col-md-6 offset-md-3 br bs bg-white p-4 text-center">
                <h5>Sign In</h5>
                <img src="@/assets/img/login.png" width="125" alt="Login Icon">
                <p>Please sign in to continue to <b class="text-warning">Darmasiswa</b></p>
                <form class="col-12 col-md-8 offset-md-2">
                    <input class="form-control" type="text" placeholder="Email" v-model="form.email">
                    <br>
                    <input class="form-control" type="password" placeholder="Password" v-model="form.password">
                    <br>
                    <p v-if="showStatus" :class="{ 'text-danger': statusClass === 'error', 'text-secondary': statusClass === 'authenticating' }">{{ statusText }}</p>
                    <br>
                    <div class="text-right mb-4">
                        <button v-if="!isProcessing" @click="onLogin" class="btn btn-primary pl-4 pr-4">Sign in</button>
                        <ClipLoader v-else :loading="isProcessing" />
                    </div>
                </form>
            </div>
        </div>
    </div>
    <Footer />
  </div>
</template>

<script>
const CryptoJS = require("crypto-js");
const config = require('../config/config.js');
const { aes } = config;
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import Topbar from '../components/Topbar.vue'
import Footer from '../components/Footer.vue'

export default {
  components: {
    Topbar,
    Footer,
    ClipLoader,
  },
  data() {
    return {
      form: {
        email: '',
        password: '',
      },
      showStatus: false,
      isProcessing: false,
      statusText: '',
      statusClass: '',
    };
  },
  methods: {
    async onLogin() {
      this.showStatus = true
      this.isProcessing = true
      this.statusClass = 'authenticating'
      this.statusText = 'Authenticating'

      if (this.form.email !== null && this.form.password !== null) {
        try {
          const payload = {
            scope: 'login',
            data: {
              email: this.form.email,
              password: this.form.password,
            },
          };

          let user = await this.$store.dispatch('user', payload);
          if (user.data.status) {
            this.showStatus = false
            this.isProcessing = false
            this.statusClass = ''
            this.statusText = ''

            let dataUser = user.data.data; 
            dataUser.access_token = user.data.access_token;
            localStorage.setItem('dataUser', CryptoJS.AES.encrypt(JSON.stringify(dataUser), aes));
            this.$store.commit('setIsLogin');
            if (dataUser.isAdmin) {
              this.$router.push({name: 'administrator', params: { type: 'search-user' }});
            } else {
              this.$router.push({name: 'home'})
            }
          } else {
            if (typeof user.data.message.email !== 'undefined' && !user.data.message.includes('Incorrect username or password')) {
              this.showStatus = true
              this.isProcessing = false
              this.statusClass = 'error'
              this.statusText = 'The Email and Password Field is Required!'
            } else if (user.data.message.includes('Incorrect username or password')) {
              this.showStatus = true
              this.isProcessing = false
              this.statusClass = 'error'
              this.statusText = 'Incorrect Username and Password!'
            } else if (user.data.message.includes('Invalid Password')) {
              this.showStatus = true
              this.isProcessing = false
              this.statusClass = 'error'
              this.statusText = 'Invalid Password!'
            }
          }
        } catch (err) {
          this.showStatus = true
          this.isProcessing = false
          this.statusClass = 'error'
          this.statusText = 'Error occured please try again!'
        }
      } else {
        this.showStatus = true
        this.isProcessing = false
        this.statusClass = 'error'
        this.statusText = 'Please fill the email and password!'
      }
    },
  },
};
</script>
